import React from "react";

interface ClipLoaderProps {
  size?: number;
  className?: string;
  thickness?: number;
  speed?: number;
}

const ClipLoader: React.FC<ClipLoaderProps> = ({
  size = 20,
  className = "",
  thickness = 2,
  speed = 1.5,
}) => {
  const spinKeyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  return (
    <div
      className={`${className}`}
      style={{
        position: "relative",
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <style>{spinKeyframes}</style>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          border: `${thickness}px solid rgba(0, 0, 0, 0.1)`,
          borderTopColor: "currentColor",
          borderRadius: "50%",
          animation: `spin ${speed}s linear infinite`,
        }}
      />
    </div>
  );
};

export default ClipLoader;
